/**
 * RiderStatusPage Component
 * 라이더 현황 페이지 - 라이더들의 실시간 상태 및 통계
 */
import React from 'react';
import Loading from '@/shared/components/feedback/Loading';
import { useRiderStatus } from '../hooks/useRiderStatus';
import FilterSection from './FilterSection';
import RiderTable from './RiderTable';
import '../styles/RiderStatusPage.css';

// ========================================
// Component
// ========================================
const RiderStatusPage: React.FC = () => {
    // ========================================
    // Hooks
    // ========================================
    const {
        // 상태
        riders,
        contractStatusCounts,
        loading,
        currentPage,
        excelDownloading,
        totalPages,
        suppliers,
        suppliersLoading,
        filters,
        userType,

        // 핸들러
        handlePageChange,
        handleRiderClick,
        handleFilterChange,
        handleKeyDown,
        searchRiders,
        handleExcelDownload,

        // 유틸리티
        getContractBadge,
        getPrepaymentBadge
    } = useRiderStatus();

    // ========================================
    // Render - Loading State
    // ========================================
    if (loading) {
        return (
            <div className="rider-status-content">
                <div className="loading-container">
                    <Loading message="라이더 정보를 불러오는 중..." />
                </div>
            </div>
        );
    }

    // ========================================
    // Render - Main
    // ========================================
    return (
        <div className="rider-status-content">
            {/* 페이지 헤더 */}
            <div className="page-header">
                <h1 className="page-title">라이더 현황</h1>
            </div>

            {/* 검색 필터 영역 */}
            <FilterSection
                filters={filters}
                suppliers={suppliers}
                suppliersLoading={suppliersLoading}
                userType={userType}
                loading={loading}
                excelDownloading={excelDownloading}
                onFilterChange={handleFilterChange}
                onKeyDown={handleKeyDown}
                onSearch={searchRiders}
                onExcelDownload={handleExcelDownload}
            />

            {/* 검색 결과 건수 */}
            <div className="result-count">
                <i className="fas fa-list"></i>
                <span>전체: <strong>{contractStatusCounts.total.toLocaleString()}건</strong></span>
                <span className="divider">|</span>
                <span>계약중: <strong>{contractStatusCounts.underContract.toLocaleString()}건</strong></span>
                <span className="divider">|</span>
                <span>계약종료: <strong>{contractStatusCounts.terminatedContract.toLocaleString()}건</strong></span>
                <span className="divider">|</span>
                <span>계약대기: <strong>{contractStatusCounts.contractPending.toLocaleString()}건</strong></span>
            </div>

            {/* 라이더 테이블 영역 */}
            <RiderTable
                riders={riders}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onRiderClick={handleRiderClick}
                getContractBadge={getContractBadge}
                getPrepaymentBadge={getPrepaymentBadge}
            />
        </div>
    );
};

export default RiderStatusPage;
